import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

// Utility function to create unique thunks
export const createApiThunk = (prefix, method) => {
    return createAsyncThunk(`${prefix}/${method}`, async (payload, { rejectWithValue }) => {
        try {
            const { path, data = {}, config = {}, imageForm = false } = payload;

            // Centralized Axios Instance
            const axiosInstance = axios.create({
                baseURL: baseUrl,
                headers: {
                    "Content-Type": imageForm ? "multipart/form-data" : "application/json",
                },
                validateStatus: (status) => {
                    // Accept only 2xx status codes as successful
                    return status >= 200 && status < 300;
                },
            });

            let response;
            if (method === "fetch") {
                response = await axiosInstance.get(path, config);
            } else if (method === "save") {
                response = await axiosInstance.post(path, data, config);
            } else {
                throw new Error("Unsupported method type");
            }

            return response; // Only return the data from the response
        } catch (error) {
            if (error.response) {
                // Server responded with a status code outside the 2xx range
                return rejectWithValue({
                    status: error.response.status || "unknown", // Ensure status is never undefined
                    message: error.response.data || "Server Error",
                });
            } else if (error.request) {
                // Request was made but no response received
                return rejectWithValue({
                    status: null,
                    message: "No response received from server",
                });
            } else {
                // Other errors (e.g., request setup issues)
                return rejectWithValue({
                    status: null,
                    message: error.message || "An unknown error occurred",
                });
            }
        }
    });
};

// Utility Function for State Updates
export const updateState = (state, type, key, payload = {}) => {
    switch (type) {
        case "pending":
            state[key] = {
                loading: true,
                success: false,
                error: false,
                message: null,
                data: null,
            };
            break;
        case "fulfilled":
            const { status = null, message, data } = payload;
            state[key] = {
                loading: false,
                success: status === "true" || status === true ? true : false,
                error: status === "true" || status === true ? false : true,
                message: message || (status === "true" ? "Operation successfully done." : "Operation failed."),
                data: status == "true" || status == true ? data : null,
            };
            break;
        case "rejected":
            state[key] = {
                loading: false,
                success: false,
                error: true,
                message: payload || "Something went wrong.",
                data: null,
            };
            break;
        default:
            break;
    }
};















// import { createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// const baseUrl = process.env.REACT_APP_BASE_URL;

// // Centralized Axios Instance
// const axiosInstance = axios.create({
//     baseURL: baseUrl,
//     headers: {
//         "Content-Type": "application/json",
//         // Authorization: `Bearer 7fa5d115dbbf825a0a4abb2b2a7f37de`,
//         // Authentication: `Bearer 7fa5d115dbbf825a0a4abb2b2a7f37de`,
//     }
// });

// export const getData = createAsyncThunk("getData", async (path, { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.get(path);
//         return response;
//     } catch (error) {
//         return rejectWithValue(error.response?.data || "Something went wrong");
//     }
// });

// export const saveData = createAsyncThunk("saveData", async (body, { rejectWithValue }) => {
//     try {
//         const { path, data, imageForm = false } = body
//         const response = await axiosInstance.post(path, data, imageForm && { headers: { "Content-Type": "multipart/form-data" } });
//         return response;
//     } catch (error) {
//         // return rejectWithValue(error.response?.data.message || "Something went wrong");
//     }
// });




// export { updateState }